<template lang="pug">
  el-card.box-processo(shadow="hover")
    h1 Atualizar Processo
    div.container
      label.labelSelect Cadastro:
        el-select.selectStatus(placeholder="Selecione o(s) cadastro(s)", v-model="tiposCadastroSelecionados", multiple, collapse-tags, collapse-tags-tooltip, filterable)
          el-option(v-for="cadastro in tiposCadastro" :key="cadastro" :label="cadastro" :value="cadastro")
      label.labelSelect Setor:
        el-select.selectStatus(placeholder="Selecione o(s) setores(s)", v-model="setoresSelecionados", multiple, collapse-tags, collapse-tags-tooltip, filterable)
          el-option(v-for="setor in setores" :key="setor" :label="setor" :value="setor")
      label.labelSelect Status:
        el-select.selectStatus(placeholder="Selecione o(s) status", v-model="statusSelecionados", multiple, collapse-tags, collapse-tags-tooltip, filterable)
          el-option(v-for="s in status" :key="s.codigo" :label="s.nome" :value="s.codigo")
      el-checkbox(v-model="atualizaSubProcesso" label="Atualizar Sub Processo")
    div.containerBotao
      el-button.botao(@click="enviar") enviar
</template>
<script>
import AppLabel from '@/components/AppLabel'
import AppNotificacao from '@/components/mixins/AppNotificacao'
import AppEditorTexto from '@/components/AppEditorTexto'
import {buscarTiposCadastros} from '@/utils/manutencao'
import { buscarSetores, buscarStatus, enviarDadosVerificaAtualizaFluxo } from '../../utils/manutencao'

export default {
  components: {
    AppLabel,
    AppEditorTexto
  },

  data () {
    return {
      tiposCadastro: [],
      setores: [],
      tiposCadastroSelecionados: [],
      setoresSelecionados: [],
      status: [],
      statusSelecionados: [],
      atualizaSubProcesso: false
    }
  },
  async created () {
    try {
      this.tiposCadastro = await buscarTiposCadastros()
      this.setores = await buscarSetores()
      this.status = await buscarStatus()
    } catch (e) {
      this.showNotificacao(this.$messages.TIPO_ERROR, this.$messages.TITULO_ERROR, 'Erro ao buscar dados')
    }
  },
  mixins: [
    AppNotificacao
  ],

  methods: {
    async enviar () {
      if (this.statusSelecionados.length > 0 && this.setoresSelecionados.length > 0 && this.tiposCadastroSelecionados.length > 0) {
        try {
          await enviarDadosVerificaAtualizaFluxo(this.statusSelecionados, this.setoresSelecionados, this.tiposCadastroSelecionados, this.atualizaSubProcesso)
          this.showNotificacao(this.$messages.TIPO_SUCCESS, this.$messages.TIPO_SUCCESS, 'Processo atualizado!')
          this.tiposCadastroSelecionados = []
          this.setoresSelecionados = []
          this.statusSelecionados = []
          this.atualizaSubProcesso = false
        } catch (e) {
          this.showNotificacao(this.$messages.TIPO_ERROR, this.$messages.TITULO_ERROR, 'Erro ao atualizar processo')
        }
      } else {
        this.showNotificacao(this.$messages.TIPO_WARNING, this.$messages.TITULO_WARNING, 'Preencha todos os campos!')
      }
    }
  }
}
</script>
<style lang="scss" scoped>
.titulo {
    margin-top: 0;
  }
.box-processo {
  min-width: 700px;
  padding-left: 3px;
  padding-right: 3px;
  }
.botao {
  width: 100px;
  height: 40px;
  align-items: center;
}
.container {
  display: flex;
  flex-direction: column;
  justify-content: center;
  margin: 10px;
  align-items: center;
}
.selectStatus {
  width: 500px;
}
.containerBotao {
  width: 100%;
  display: flex;
  justify-content: right;
}

.labelSelect {
    display: flex;
    flex-direction: column;
    margin: 5px
  }

</style>



// WEBPACK FOOTER //
// src/screens/manutencao/AtualizarProcessos.vue